var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.getItems.length >= 1
    ? _c(
        "ul",
        { staticClass: "action action--buttons" },
        [
          _vm._l(_vm.getItems, function (item) {
            return [
              _c(
                "li",
                { staticClass: "action--buttons__item" },
                [
                  item.router
                    ? [
                        _c(
                          "router-link",
                          {
                            staticClass: "button button--action",
                            class: item.class,
                            attrs: {
                              to: item.router,
                              title: item.title,
                              disabled:
                                _vm.isDisabled &&
                                ["activate", "deactivate", "cancel"].indexOf(
                                  item.action
                                ) === -1,
                              tabindex: "-1",
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(item.title))])]
                        ),
                      ]
                    : [
                        _c(
                          "button",
                          {
                            staticClass: "button button--action",
                            class: item.class,
                            attrs: {
                              role: "button",
                              title: item.title,
                              disabled:
                                _vm.isDisabled &&
                                ["activate", "deactivate", "cancel"].indexOf(
                                  item.action
                                ) === -1,
                              tabindex: "-1",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onClickAction(item.action)
                              },
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(item.title))])]
                        ),
                      ],
                ],
                2
              ),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }